import config from '@/config';

import './BoardCardTWO.css';

export default function BoardCardTWO({ item = {}, showQuestion = false, showOptions = false, }) {
  if (!item) return null;

  const imageUrl = item.image
    ? `${config.app.imageServiceDomain}/${item.image}/w=300`
    : null;
  const question = item.question;
  const title = item.title;
  const description = item.description;
  const optionList = showOptions
    ? item.options?.text?.[item.pollIndex ?? item.quizIndex ?? 0] || []
    : [];

  return (
    <div className="pq-card">
      {showQuestion && question && (
        <p className="pq-card__question">{question}</p>
      )}
      <div className="pq-card__cover-wrapper">
        {imageUrl ? (
          <img className="pq-card__cover" src={imageUrl} alt="Background image" />
        ) : (
          <div className="pq-card__cover pq-card__cover--placeholder" />
        )}
        {showOptions && optionList.length > 0 && (
          <div className="polls-quizzes-slider__article-name">
            {optionList.map((opt, idx) => (
              <div key={idx} className="submitted-poll-option-input">
                {opt}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="pq-card__content">
        {title && <p className="pq-card__title">{title}</p>}
        {description && (
          <div className="pq-card__description">{description}</div>
        )}
      </div>
    </div>
  );
}